export default __webpack_public_path__ + "static/media/managingtime_sl_results.3cd96db9.png";